export default __webpack_public_path__ + "static/media/handy-mailbox-sends-mail.6c2ffbd3.png";